/**
 * 🗺️ Roadmap Domain API Custom Axios Instance
 * shared/auth-core 통합 버전 - 로드맵 관리 기능 특화
 */

import { createOrvalCustomInstance } from '@edusense/shared-auth-core';

// Roadmap API 베이스 URL (환경별 설정)
const getRoadmapApiBaseUrl = (): string => {
  const configuredBaseUrl =
    process.env.VITE_ROADMAP_API_BASE_URL ||
    process.env.ROADMAP_API_BASE_URL ||
    process.env.NEXT_PUBLIC_ROADMAP_API_BASE_URL;

  if (configuredBaseUrl && configuredBaseUrl.trim().length > 0) {
    return configuredBaseUrl;
  }

  return 'https://api.ugot.uk';
};

// Roadmap 도메인용 커스텀 인스턴스 생성
export const customInstance = createOrvalCustomInstance(
  getRoadmapApiBaseUrl(),
  {
    timeout: 30000,
    enableDebug: process.env.NODE_ENV === 'development',
    onAuthError: () => {
      console.warn('API 인증 만료 - 토큰만 정리하고 현재 페이지 유지');
    },
  }
);

export type ErrorType<T> = import('@edusense/shared-auth-core').AuthAxiosError<T>;
